import {
    Box,
    Button,
    Container,
    Stack,
    Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import AdminPanelManageJobPostCard from './AdminPanelManageJobPostCard/AdminPanelManageJobPostCard';
import AdminPanelManageUserCard from './AdminPanelManageUserCard';

export const jobFormSchema = z.object({
    jobTitle: z.string().min(1, 'Job title is required').max(100, 'Job title must be less than 100 characters'),
    pmEmail: z.string().min(1, 'PM email is required').email('Invalid email format'),
    jobDescription: z.string().min(10, 'Job description should be at least 10 characters'),
    location: z.string().min(1, 'Location is required'),
    category: z.array(z.string()).min(1, 'Category is required'),
    type: z.array(z.string()).min(1, 'Type is required'),
    salary: z.string().min(1, 'Salary is required'),
    company: z.string().min(1, 'Company is required'),
});

export const jobTypeMap = {
    'FullTime': 'Full-time',
    'PartTime': 'Part-time',
    'Contract': 'Contract',
    'Temporary': 'Temporary',
    'Volunteer': 'Volunteer',
    'Internship': 'Internship'
} as const;
export type JobType = keyof typeof jobTypeMap;

export const categoryMap = {
    'IT': 'IT',
    'Finance': 'Finance',
    'Marketing': 'Marketing',
    'Sales': 'Sales',
    'HR': 'HR'
} as const;
export type JobCategory = keyof typeof categoryMap;

export type JobFormInputs = z.infer<typeof jobFormSchema>;

const AdminPanel = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ overflowX: 'auto' }}>
            <Stack gap={2}>
                <Typography variant="h5" sx={{ fontWeight: 'bold', cursor: 'pointer' }} >
                    CMS Management
                </Typography>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ borderRadius: 1, mb: 3 }}
                        onClick={() => navigate('/jobs')}
                    >
                        Go to Post Page
                    </Button>

                    <AdminPanelManageJobPostCard />
                    <AdminPanelManageUserCard />
                </Box>
            </Stack>
        </Container>
    );
};

export default AdminPanel;  
